import { useEffect } from 'react'
import { Layer } from 'types'
import { useCurrentArticleId } from 'hooks/useCurrentArticleId'
import { useCurrentLayer } from 'hooks/useCurrentLayer'
import { useInformalFeedbackRequests } from 'hooks/useInformalFeedbackRequests'
import { reviewStore } from 'stores/Review'

const ConfigureReviewsBySection = ({ layer }: { layer: Layer }) => {
  const { informalFeedbackRequests } = useInformalFeedbackRequests(layer.article_id, layer.id)
  const reviewsBySectionEnabled = informalFeedbackRequests.length === 0
  useEffect(() => {
    reviewStore.enabled = reviewsBySectionEnabled
  }, [reviewsBySectionEnabled])
  return null
}

const WireCurrentLayer = ({ articleKey }: { articleKey: string }) => {
  const layer = useCurrentLayer({ articleKey })
  return layer ? <ConfigureReviewsBySection layer={layer} /> : null
}

export const ReviewsBySection = () => {
  const articleKey = useCurrentArticleId()
  return articleKey ? <WireCurrentLayer articleKey={articleKey} /> : null
}
